export const COLORS = [
  '#00C48C',
  '#1183F6',
  '#CB76DA',
  '#FF7A00',
  '#F11D00',
  '#9D21C8',
  '#73B8FE',
  '#C9E4FF',
]
